'use strict';

module.exports.ResponsiveConfig = {
    mobile: 480,
    tablet:800,
    landscape: 1024,
    desktop:1280
}


// WEBPACK FOOTER //
// ./src/config/responsive.config.js